import { Device } from "./types";
import { UseResponsiveValue } from "./use-responsive";

export const defaultResponsiveValue = {
  device: "mobile",
  is: (device: Device) => device === "mobile",
  isDesktop: false,
  isGreaterThanDesktop: false,
  isGreaterThanLaptop: false,
  isGreaterThanMobile: false,
  isGreaterThanTablet: false,
  isGreaterThanWide: false,
  isLaptop: false,
  isLargeMobile: false,
  isLowerThanDesktop: true,
  isLowerThanLaptop: true,
  isLowerThanTablet: true,
  isLowerThanUltraWide: true,
  isLowerThanWide: true,
  isMobile: true,
  isTablet: false,
  isUltraWide: false,
  isWide: false,
} as UseResponsiveValue;
